// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EyeFilledSvg from "@ant-design/icons-svg/es/asn/EyeFilled";
import AntdIcon from '../components/AntdIcon';

var EyeFilled = function EyeFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: EyeFilledSvg
  }));
};

EyeFilled.displayName = 'EyeFilled';
export default React.forwardRef(EyeFilled);